/* app/controls/control.grid-rotator */

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

const selectors = {
	carousel: '.js-grid-carousel', // Used to select all carousels
};

var module = {
	init: function () {
		const $elms = document.querySelectorAll(selectors.carousel);
		if ($elms.length > 0) {
			$elms.forEach((carousel) => {
				module._initGridCarousel(carousel); // Initialize each Swiper individually
			});
		}
	},

	_initGridCarousel: function (carousel) {
		//console.log("Initializing Swiper for:", carousel);

		// Check the width of the carousel and initialize the appropriate swiper config
		module._checkSwiperConfig(carousel);
	},

	_checkSwiperConfig: function (carousel) {
		const width = carousel.offsetWidth;
		let swiperConfig;

		// Determine the appropriate configuration based on the width
		if (width >= 1200) {
			swiperConfig = swiperConfigLarge; // Use large configuration (4 slides per view)
		} else if (width >= 480) {
			swiperConfig = swiperConfigMedium; // Use medium configuration (2 slides per view)
		} else {
			swiperConfig = swiperConfigSmall; // Use small configuration (1 slide per view)
		}

		// Initialize Swiper with the selected config
		module._initializeSwiperWithConfig(carousel, swiperConfig);
	},

	_initializeSwiperWithConfig: function (carousel, config) {
		const swiper = new Swiper(carousel, config);

		//console.log("Swiper instance initialized:", swiper);
		carousel.swiper = swiper; // Store swiper instance on the carousel element
	},

	_toggleNavigationVisibility: function (swiper) {
		if (!swiper.navigation || !swiper.navigation.nextEl || !swiper.navigation.prevEl) return;

		const totalSlides = swiper.slides.length;
		const slidesPerView = swiper.params.slidesPerView;
		const slidesToShow = typeof slidesPerView === 'function' ? slidesPerView(swiper) : slidesPerView;
		const navigationVisible = totalSlides > slidesToShow;
		const navigationButtons = [
			swiper.navigation.nextEl,
			swiper.navigation.prevEl
		];

		navigationButtons.forEach((button) => {
			if (button) {
				button.style.display = navigationVisible ? 'block' : 'none';
				button.style.marginBottom = navigationVisible ? '40px' : '0';
			}
		});
	},

	_checkAndReinitSwiper: function (carousel) {
		let lastWidth = carousel.offsetWidth;

		const throttledReinit = module._throttle(() => {
			const newWidth = carousel.offsetWidth;

			// Check if the container width has changed significantly
			if (Math.abs(newWidth - lastWidth) > 50) {
				//console.log(`Reinitializing Swiper: ${newWidth}px`);
				if (carousel.swiper) {
					carousel.swiper.destroy(true, true);  // Destroy the old Swiper instance
				}
				module._checkSwiperConfig(carousel);  // Recheck and initialize with new config
			}

			lastWidth = newWidth;  // Update the lastWidth for next check
		}, 500); // Throttle the resize check to run at most every 500ms

		// Listen for window resize events
		window.addEventListener("resize", throttledReinit);
	},

	_throttle: function (func, limit) {
		let inThrottle;
		return function () {
			if (!inThrottle) {
				func();
				inThrottle = true;
				setTimeout(() => (inThrottle = false), limit);
			}
		};
	},
};

// Configurations for different screen sizes
const swiperConfigSmall = {
	modules: [Navigation],
	navigation: {
		enabled: false,
	},
	slidesPerView: 1,
	centerMode: false,
	on: {
		init: function () {
			module._toggleNavigationVisibility(this);
			module._checkAndReinitSwiper(this.el); // Pass the carousel element to recheck the config
		},
		resize: function () {
			module._toggleNavigationVisibility(this);
		},
		slideChange: function () {
			module._toggleNavigationVisibility(this);
		},
	},
};

const swiperConfigMedium = {
	modules: [Navigation],
	navigation: {
		nextEl: '.js-grid-carousel__next',
		prevEl: '.js-grid-carousel__prev',
	},
	slidesPerView: 2,
	centerMode: false,
	on: {
		init: function () {
			module._toggleNavigationVisibility(this);
			module._checkAndReinitSwiper(this.el); // Pass the carousel element to recheck the config
		},
		resize: function () {
			module._toggleNavigationVisibility(this);
		},
		slideChange: function () {
			module._toggleNavigationVisibility(this);
		},
	},
};

const swiperConfigLarge = {
	modules: [Navigation],
	navigation: {
		nextEl: '.js-grid-carousel__next',
		prevEl: '.js-grid-carousel__prev',
	},
	slidesPerView: 4,
	centerMode: false,
	on: {
		init: function () {
			module._toggleNavigationVisibility(this);
			module._checkAndReinitSwiper(this.el); // Pass the carousel element to recheck the config
		},
		resize: function () {
			module._toggleNavigationVisibility(this);
		},
		slideChange: function () {
			module._toggleNavigationVisibility(this);
		},
	},
};

export { module as GridCarousel };
